export const REDIRECT_AFTER_LOGIN = 'redirect-after-login';
